import { createSelector } from '@reduxjs/toolkit';
import type { RootState } from '@core';
import type { EventResponse } from '../models/show.interface';

/**
 * Базовый селектор для доступа к состоянию модуля dateSelection
 */
const dateSelectionStateSelectors = createSelector(
  (state: RootState) => state,
  state => state.dateSelection
);

/**
 * Селектор для получения информации о шоу
 */
export const showInfoSelectors = createSelector(
  dateSelectionStateSelectors,
  state => state.showInfo
);

/**
 * Селектор для получения статуса загрузки
 */
export const isLoadingSelectors = createSelector(
  dateSelectionStateSelectors,
  state => state.isLoading
);

/**
 * Селектор для получения ошибок
 */
export const errorsSelectors = createSelector(dateSelectionStateSelectors, state => state.error);

/**
 * Селектор для получения выбранного события
 */
export const selectedEventSelectors = createSelector(
  dateSelectionStateSelectors,
  ({ selected, showInfo }) => {
    if (!selected || !showInfo?.events) return null;
    return showInfo.events.find((event: EventResponse) => event.id === selected.eventId) || null;
  }
);

/**
 * Селектор для получения информации о выбранной дате и времени
 */
export const selectedDateSelectors = createSelector(
  dateSelectionStateSelectors,
  state => state.selected
);

/**
 * Селектор для получения информации о месте проведения
 */
export const venueInfoSelectors = createSelector(
  dateSelectionStateSelectors,
  state => state.venueInfo
);
